import Vue from 'vue'

const state = {
    begin_date: null,
    end_date: null
}

const actions = {
    SET_BEGIN_DATE(context, [begin_date]) {
        context.commit('SAVE_BEGIN_DATE', [begin_date])
    },

    SET_END_DATE(context, [end_date]) {
        context.commit('SAVE_END_DATE', [end_date])
    }
}

const mutations = {
    SAVE_BEGIN_DATE: (state, [begin_date]) => {
        Vue.set(state, 'begin_date', begin_date)
    },

    SAVE_END_DATE: (state, [end_date]) => {
        Vue.set(state, 'end_date', end_date)
    }
}

const getters = {
    begin_date: state => {
        return state.begin_date
    },

    end_date: state => {
        return state.end_date
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}